<template>
  <div class="preview-messages-container">
    <div
      class="preview-message-cont px-2 py-0 d-flex"
      v-for="(message, index) in messages"
      :key="`message-${index}`"
    >
      <div>
        <div class="d-flex align-top mb-0">
          <div>
            <v-sheet
              elevation="0"
              rounded
              class="px-0"
              color="transparent"
            >
              <div>
                <small>{{ message.author.name }}: {{ message.message }}</small>
              </div>
            </v-sheet>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  watch: {
    'messages': function () {
      this.updateScroll()
    }
  },
  computed: {
    messages () {
      return this.$store.state.rooms.item.chat.messages
    }
  }
})
export default class MessagesPreview extends Vue {
  creationTime (date) {
    const creationTime = new Date(date)
    const minutes = creationTime.getMinutes()
    return `${creationTime.getHours()}:${minutes < 10 ? '0' : ''}${minutes}`
  }

  updateScroll () {
    setTimeout(() => {
      const lastMessageElement = document.querySelector('.preview-message-cont:last-child')
      if (lastMessageElement) {
        lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
      }
    }, 100)
  }
}
</script>

<style scoped>
.preview-messages-container {
  max-height: 100px !important;
  overflow: hidden
}

.preview-message-cont small {
  color: white !important;
  line-height: .1 !important;
  text-shadow: 1px 1px #3b3b3b;
}
</style>
